module.exports = __webpack_public_path__ + "static/media/chase.f25b7406.jpeg";